export default __webpack_public_path__ + "img/Seomatic-icon.svg";